<template>
    <div class="">
        <div class="row">
            <div class="column">
                <h2 class="join__heading typo-d2">{{ translation_title }}</h2>
                <p
                    class="join__subtitle typo-b1"
                    v-html="translation_perex"
                ></p>
            </div>
        </div>
        <div class="join__job-offers job-offers row">
            <div class="column">
                <div>
                    <div class="loader job-offers__loader" v-if="!isDataLoaded">
                        Loading...
                    </div>
                    <table class="job-offers__table" v-show="isDataLoaded">
                        <thead class="job-offers__head">
                            <job-offers-filter
                                v-if="jobs.length > 0"
                                :translation_offices="translation_offices"
                                :translation_departments="
                                    translation_departments
                                "
                                :translation_position="translation_position"
                            />
                        </thead>
                        <tbody class="job-offers__body">
                            <transition name="fade">
                                <div
                                    class="job-offers__overlay"
                                    v-if="!isDataLoaded"
                                ></div>
                            </transition>

                            <div
                                v-if="paginated_jobs.length == 0"
                                class="job-offers__no-results"
                            >
                                <p>
                                    {{ no_result_text }}
                                </p>
                            </div>
                            <tr
                                class="job-offers__row"
                                v-for="job in paginated_jobs"
                                :key="job.id"
                            >
                                <td
                                    class="job-offers__data-item job-offers__data-position"
                                >
                                    <a
                                        :href="job.url"
                                        target="_blank"
                                        class="job-offers__mobile-link"
                                        >{{ job.position }}
                                    </a>
                                </td>
                                <td
                                    class="job-offers__data-item job-offers__data-department"
                                >
                                    {{ job.department }}
                                </td>
                                <td
                                    class="job-offers__data-item job-offers__data-office"
                                >
                                    {{ job.office }}
                                </td>
                                <td
                                    class="job-offers__data-item job-offers__data-item--invisible"
                                ></td>
                                <td class="job-offers__data-item">
                                    <a
                                        :href="job.url"
                                        target="_blank"
                                        class="job-offers__data-link"
                                    >
                                        <img
                                            src="/svg/workplaces/sipka.svg"
                                            :alt="
                                                translation_interest +
                                                    ' in ' +
                                                    job.position
                                            "
                                        />
                                        <strong
                                            >{{ translation_interest }}
                                        </strong>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <job-offers-pagination
                        v-if="jobs.length > 0"
                        ref="pagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import JobOffersPagination from "../JobOffersFilter/JobOffersPagination.vue";
import JobOffersFilter from "../JobOffersFilter/JobOffersFilter.vue";

export default {
    components: { JobOffersPagination, JobOffersFilter },
    props: [
        "translation_departments",
        "translation_offices",
        "translation_interest",
        "translation_position",
        "translation_title",
        "translation_perex",
        "translation_noresult"
    ],
    data: function() {
        return {
            no_result_text: ""
        };
    },
    mounted() {
        this.load_jobs();
        this.load_translations();
        this.check_country();
    },

    methods: {
        ...mapActions(["load_jobs"]),
        load_translations() {
            axios("/get-translations").then(response => {
                this.no_result_text = response.data;
            });
        },
        check_country() {
            this.set_office_based_on_country;
        }
    },
    computed: {
        ...mapGetters([
            "paginated_jobs"
            // ...
        ]),
        ...mapState(["jobs", "isDataLoaded"]),
        ...mapMutations(["set_office_based_on_country"])
    }
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.job-offers__no-results {
    width: 100%;
    text-align: center;
    position: absolute;
}
</style>
